// extracted by mini-css-extract-plugin
export default {"description":"VendorEmailVerified_description__L3b+4","first_txt":"VendorEmailVerified_first_txt__ficRg","lst_txt":"VendorEmailVerified_lst_txt__Z0ggg"};